import { store } from "../store";
import { router } from "../router";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
export const message = {
  success,
  error,
  success_reload
};

function success(text, path){
  NProgress.done();
  store.dispatch("alert/success", text, { root: true });
  if (path) {
    router.push(path);
  }
}

function error(text, path){
  store.dispatch("alert/error", text, { root: true });
  if (path) {
    router.push(path);
  }
}

function success_reload(text, path){
  store.dispatch("alert/success", text, { root: true });
  //debugger;
  if (path) {
    router.go(path);
  }
  //
}